import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";

import { ReactComponent as EditDocumentIcon } from "../../../../build/images/nps-dashboard-icons/edit_document.svg";
import { ReactComponent as SentimentExcitedIcon } from "../../../../build/images/nps-dashboard-icons/sentiment_excited.svg";
import { ReactComponent as MoodBadIcon } from "../../../../build/images/nps-dashboard-icons/mood_bad.svg";
import { ReactComponent as SentimentExtremelyDissatisfiedIcon } from "../../../../build/images/nps-dashboard-icons/sentiment_extremely_dissatisfied.svg";

import "./nps-date-two.css";
import Paperplane from "../../../Loading/Paperplane";
import {
  getNpsResultCallV2,
  getResearchHandledCall,
} from "../../../../actions";
import axios from "axios";

export default function NpsDateTwo() {
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );
  const cardsOfCallCenterDash = useSelector(
    (state) => state.cardsOfCallCenterDash
  );

  const [dataSearch, setDataSearch] = useState({
    mudancaPerfil: 0,
    notasAlteradas: 0,
    pesquisasTrat: 0,
  });
  const [loadingProfileCards, setLoadingProfileCards] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [moodProfileCards, setMoodProfileCards] = useState([
    {
      icon: <SentimentExcitedIcon />,
      profile: "Promotores",
      value: 0,
    },
    {
      icon: <MoodBadIcon />,
      profile: "Neutros",
      value: 0,
    },
    {
      icon: <SentimentExtremelyDissatisfiedIcon />,
      profile: "Detratores",
      value: 0,
    },
  ]);

  async function getResearchHandled(source) {
    setLoadingSearch(true);

    const response = await getResearchHandledCall(
      format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      ),
      format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd"),
      agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      source
    );

    if (response && response.status === 200) {
      const data = response.data;

      setDataSearch({
        mudancaPerfil: data[0].mudanca_perfil,
        notasAlteradas: data[0].notas_alteradas,
        pesquisasTrat: data[0].pesquisas_tratadas,
      });
      setLoadingSearch(false);
    } else {
      setDataSearch({
        mudancaPerfil: 0,
        notasAlteradas: 0,
        pesquisasTrat: 0,
      });
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setLoadingSearch(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  async function getMoodProfileCards(source) {
    let updatedMoodProfileCards = [
      {
        icon: <SentimentExcitedIcon />,
        profile: "Promotores",
        value: 0,
      },
      {
        icon: <MoodBadIcon />,
        profile: "Neutros",
        value: 0,
      },
      {
        icon: <SentimentExtremelyDissatisfiedIcon />,
        profile: "Detratores",
        value: 0,
      },
    ];
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const channelId = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join();
    const avaliationId = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join();

    const response = await getNpsResultCallV2(
      dateStart,
      dateEnd,
      channelId,
      avaliationId,
      source
    );
    setLoadingProfileCards(true);
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        let promoterQtd = 0;
        let neutralQtd = 0;
        let detractorQtd = 0;

        const promotersData = data.find((datum) => datum.tipo === "promotor");
        const neutralData = data.find((datum) => datum.tipo === "neutro");
        const detractorData = data.find((datum) => datum.tipo === "detrator");

        const hasPromotersData = !!promotersData;
        if (hasPromotersData) {
          const promoters = Number(promotersData.qtde);
          const isPromotersAValidNumber = typeof promoters === "number";
          if (isPromotersAValidNumber) {
            promoterQtd = promoters;
          }
        }

        const hasNeutralData = !!neutralData;
        if (hasNeutralData) {
          const neutrals = Number(neutralData.qtde);
          const isNeutralsAValidNumber = typeof neutrals === "number";
          if (isNeutralsAValidNumber) {
            neutralQtd = neutrals;
          }
        }

        const hasDetractorData = !!detractorData;
        if (hasDetractorData) {
          const detractors = Number(detractorData.qtde);
          const isDetractorsAValidNumber = typeof detractors === "number";
          if (isDetractorsAValidNumber) {
            detractorQtd = detractors;
          }
        }

        updatedMoodProfileCards = [
          {
            icon: <SentimentExcitedIcon />,
            profile: "Promotores",
            value: promoterQtd,
          },
          {
            icon: <MoodBadIcon />,
            profile: "Neutros",
            value: neutralQtd,
          },
          {
            icon: <SentimentExtremelyDissatisfiedIcon />,
            profile: "Detratores",
            value: detractorQtd,
          },
        ];
      }
      setMoodProfileCards(updatedMoodProfileCards);
      setLoadingProfileCards(false);
    } else {
      setMoodProfileCards(updatedMoodProfileCards);
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setLoadingProfileCards(false);
        }
      }
    }
  }

  useEffect(() => {
    const sourceResearch = axios.CancelToken.source();
    const sourceMoodProfileCards = axios.CancelToken.source();
    if (!!agentDashboardFilter) {
      getResearchHandled(sourceResearch);
      getMoodProfileCards(sourceMoodProfileCards);
    }
  }, [agentDashboardFilter]);

  return (
    <section className="nps-date-two">
      {cardsOfCallCenterDash.card5 && (
        <div className="card-container-one-dashboard-agent">
          {loadingProfileCards ? (
            <Paperplane className="nps-date-two__loading" />
          ) : (
            <div className="card-container-one__mood-profile">
              {moodProfileCards.map((moodProfileCard, index) => {
                return (
                  <div
                    key={index}
                    className="card-container-one__mood-profile__card"
                  >
                    <div className="card-container-one__mood-profile__card__icon">
                      {moodProfileCard.icon}
                    </div>
                    <div className="card-container-one__mood-profile__card__info">
                      <p className="card-container-one__mood-profile__card__info__value">
                        {moodProfileCard.value}
                      </p>
                      <span className="card-container-one__mood-profile__card__info__profile">
                        {moodProfileCard.profile}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {cardsOfCallCenterDash.card6 && (
        <div className="card-container-two card-container-two-call-center">
          {loadingSearch ? (
            <Paperplane className="nps-date-two__loading" />
          ) : (
            <>
              <div className="research-handled">
                <span className="research-handled__icon">
                  <EditDocumentIcon />
                </span>

                <span className="research-handled__text">
                  <h1 className="research-handled__text__number">
                    {dataSearch.pesquisasTrat}
                  </h1>

                  <h6 className="research-handled__text__information">
                    Pesquisas tratadas
                  </h6>
                </span>
              </div>

              <div className="changed-notes">
                <h1 className="changed-notes__number">
                  {dataSearch.notasAlteradas}
                </h1>

                <h6 className="changed-notes__information">Notas alteradas</h6>
              </div>

              <div className="profile-change">
                <h1 className="profile-change__number">
                  {dataSearch.mudancaPerfil}
                </h1>

                <h6 className="profile-change__information">
                  Mudança de perfil
                </h6>
              </div>
            </>
          )}
        </div>
      )}
    </section>
  );
}
